<script>
	import Tab from './Tab.svelte';
	import dayjs from 'dayjs';
	import { dateFormat } from '../utils/utils.js';
	import { Icon } from '@shopboxai/sb-portal-components';
	import DateSelect from './DateSelect.svelte';
	const url = `https://storage.googleapis.com/sb-config-store/dashboard-configs/tony_kealys/tony_kealys.json`;
	let active, device;
	let startDate = dayjs(new Date()).subtract(7, 'days').format(dateFormat);
	let endDate = dayjs(new Date()).format(dateFormat);
	let dateSelected = (e) => {
		console.log('dateSelected');
		startDate = e.detail.startDate;
		endDate = e.detail.endDate;
	};
	const setToActive = (key) => {
		active = key;
	};
	const fetchConfig = async (url) => {
		const res = await fetch(url);
		let json = await res.json();
		return Object.keys(json.tabs).filter((t) => !t.startsWith('_'));
	};
	const printOrSave = () => {
		window.print();
	};
</script>

{#await fetchConfig(url)}
	<p class="loader">loading...</p>
{:then value}
	{#if value}
		<nav class="dashboard-tabs sb-scrollbar sb-scrollbar-horizontal">
			{#each value as tab, i}
				<div style="display:none">
					{#if i == 0}
						{@html setToActive(tab)}
					{/if}
				</div>

				<button
					class="dashboard-tab light"
					class:active={tab === active}
					on:click={() => setToActive(tab)}>{tab}</button
				>
			{/each}
		</nav>
		<nav class="tab-filters">
			<div class="filter-container">
				<span class="filter-icon"><Icon name="calendar" /></span><DateSelect
					on:dateSelected={dateSelected}
				/>
			</div>
			<span class="separator" />
			{#if startDate && endDate}
				<p id="print-only">
					<span class="bold">{active}</span> reports for period
					<span class="bold">{startDate}</span>
					- <span class="bold">{endDate}</span> on
				</p>
			{/if}
			<div class="filter-container">
				<span class="filter-icon"><Icon name="device" /></span>

				<select bind:value={device} name="device" id="device">
					<option value={null} selected> All Devices</option>
					<option value="desktop"> Desktop</option>
					<option value="mobile"> Tablet</option>
					<option value="mobile"> Mobile</option>
				</select>
			</div>
			<button on:click={printOrSave} class="secondary" id="save-pdf">Export as PDF</button>
		</nav>
		{#each value as tab}
			{#if active == tab}
				<Tab key={tab} {device} {startDate} {endDate} />
			{/if}
		{/each}
	{/if}
{:catch error}
	<p>No data available yet.</p>
{/await}

<style>
	.loader {
		text-align: center;
	}
	nav {
		gap: 0.5em;
		display: flex;
	}
	nav.dashboard-tabs {
		margin: 1em 0;
		overflow-x: scroll;
		max-width: calc(100vw - 220px);
	}
	nav.tab-filters {
		box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.1);
		padding: 0em 0 1em;
		align-items: center;
		flex-wrap: wrap;
	}
	.filter-container {
		display: flex;
		align-items: center;
	}
	.filter-icon {
		margin-right: 0.5em;
	}
	.light {
		color: var(--t-c-l);
	}
	.active {
		color: var(--h-c);
	}
	.separator {
		display: inline-block;
		width: 1px;
		height: 2em;
		background-color: #ddd;
		margin: 0 1em;
	}
	.dashboard-tab {
		margin-right: 1.5em;
		font-size: 22px;
		padding: 0.5em 1em;
	}
	.dashboard-tab.active {
		border-bottom: 2px solid var(--p-c);
	}
	#save-pdf {
		border: 1px solid var(--h-c);
		color: var(--h-c);
		margin-left: auto;
	}
	#print-only {
		display: none;
		font-size: 1rem;
		color: var(--l-c);
	}
	.bold {
		font-weight: 900;
	}
	@media (max-width: 640px) {
		nav.tab-filters :global(select) {
			max-width: 100%;
			flex: 1;
		}
		nav.dashboard-tabs {
			max-width: unset;
		}
	}

	@media (max-width: 660px) {
		#save-pdf {
			display: none;
		}
	}
</style>
